<template>
  <div>

    <div class="top-area">

      <div class="container">
        <!-- 左侧：Logo和标题 -->
        <div class="left-section">
          <img :src="headerLogoPath" :alt="brandConfig.name + ' Logo'" class="logo-img" :style="headerLogoStyle" @error="handleLogoError" />
          <div v-if="logoLoadError" class="logo-fallback">
            {{ brandConfig.shortName }}
          </div>
        </div>

        <!-- 中间：联系信息 -->
        <div style="display: flex; align-items: center;">
          <div class="center-section">
            <div class="contact-item" @click="handleContactClick(contactInfo[0])">
              <img src="@/assets/image/new_slices/telephone.png" class="phone-img" />
              <span>咨询电话: {{ channelPhone }}</span>
            </div>
            <div class="contact-item" @click="handleContactClick(contactInfo[1])">
              <img src="@/assets/image/new_slices/customer service.png" class="phone-img" />
              <span>{{ channelEmail }}</span>
            </div>
          </div>

          <!-- 右侧：搜索框 -->
          <!-- <div class="search-container">
          <input ref="searchInput" type="text" placeholderColor="red" placeholder="请输入关键字" class="search-input"
            v-model="searchKeyword" @keyup.enter="handleSearch" @focus="handleSearchFocus" @blur="handleSearchBlur"
            @input="handleSearchInput" />
          <div class="search-btn">
            <img src="@/assets/image/new_slices/search.png" class="search-img" />
            <span class="search-text">搜索</span>
          </div> -->

          <!-- 搜索建议下拉框 -->
          <!-- <div v-if="showSuggestions && searchSuggestions.length > 0" class="search-suggestions">
            <div v-for="(suggestion, index) in searchSuggestions" :key="suggestion.id || index" class="suggestion-item"
              :class="{ 'suggestion-active': activeSuggestionIndex === index }" @click="selectSuggestion(suggestion)"
              @mouseenter="activeSuggestionIndex = index">
              <i :class="suggestion.icon || 'el-icon-search'" class="suggestion-icon"></i>
              <span class="suggestion-text" v-html="highlightSearchTerm(suggestion.text)"></span>
              <span v-if="suggestion.category" class="suggestion-category">{{ suggestion.category }}</span>
            </div>
          </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    <!-- 顶部导航栏 -->
    <div class="nav-tabs">
      <div class="tab-item" :class="{ active: activeTab === 'home' }" @click="handleTabs(3)">首页</div>
      <div class="tab-item" :class="{ active: activeTab === 'deal' }" @click="handleTabs(0)">交易信息</div>
      <div class="tab-item" :class="{ active: activeTab === 'ca' }" @click="handleTabs(1)">CA办理</div>
      <div v-if="isChannelB" class="tab-item" @click="handleTabs(5)">信息定制</div>
      <div class="tab-item" :class="{ active: activeTab === 'download' }" @click="handleTabs(4)">下载中心</div>
      <!-- <div class="tab-item" :class="{ active: activeTab === 'expert' }" @click="handleTabs(2)">专家库</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopArea',

  data() {
    return {
      // 当前选中的标签
      activeTab: 'home',
      // 搜索相关状态
      searchKeyword: '',
      isSearchFocused: false,
      isSearching: false,
      showSuggestions: false,
      activeSuggestionIndex: -1,
      searchSuggestions: [],
      searchHistory: [],

      // Logo 加载状态
      logoLoadError: false,

      // 配置数据
      brandConfig: {
        name: this.$channelMaterial.getCompanyName() + '标平台',
        shortName: this.$channelMaterial.getCompanyName()
      },

      contactInfo: [
        {
          id: 'phone',
          action: 'call',
          phone: '400-xxx-xxxx'
        },
        {
          id: 'service',
          action: 'chat'
        }
      ],

      searchConfig: {
        placeholder: '请输入关键字',
        maxSuggestions: 8,
        debounceDelay: 300
      },

      // 防抖定时器
      searchDebounceTimer: null
    }
  },

  computed: {
    isChannelB() {
      return this.$channelMaterial.getChannelId() === 'channel_b'
    },
    headerLogoPath() {
      return this.$channelMaterial.getHeaderLogoPath()
    },
    headerLogoStyle() {
      return this.$channelMaterial.getHeaderLogoStyle()
    },
    channelPhone() {
      return this.$channelMaterial.getPhone()
    },
    channelEmail() {
      return this.$channelMaterial.getEmail()
    }
  },

  mounted() {
    this.initializeComponent()
    this.updateActiveTabByRoute()
  },

  watch: {
    '$route.path': {
      handler() {
        this.updateActiveTabByRoute()
      },
      immediate: true
    }
  },

  beforeDestroy() {
    this.cleanup()
  },

  methods: {

    // 根据路由更新选中状态
    updateActiveTabByRoute() {
      const path = this.$route.path
      if (path.includes('/deal') || path.includes('/homeDetail')) {
        this.activeTab = 'deal'
      } else if (path === '/' || path === '/home') {
        this.activeTab = 'home'
      } else if (path.includes('/download-center')) {
        this.activeTab = 'download'
      } else if (path.includes('/ca')) {
        this.activeTab = 'ca'
      }
    },
    // 设置选中标签（供外部调用）
    setActiveTab(tab) {
      this.activeTab = tab
    },
    // 处理标签页点击
    handleTabs(index) {
      switch (index) {
        case 0:
          this.activeTab = 'deal'
          this.$router.replace('/deal')
          break;
        case 1:
          this.activeTab = 'ca'
          this.$router.replace('/ca')
          break;
        case 2:
          window.open('/expertBankLogin', '_blank')
          break;
        case 3:
          this.activeTab = 'home'
          this.$router.replace('/');
          break;
        case 4:
          this.activeTab = 'download'
          this.$router.replace('/download-center')
          break;
        case 5:
          window.open('http://www.cebpubservice.com/custom/index.html', '_blank')
          break;
        default:
          break;
      }
    },
    /**
     * 初始化组件
     */
    initializeComponent() {
      this.loadSearchHistory()
      this.setupGlobalClickListener()
    },

    /**
     * 设置全局点击监听器
     */
    setupGlobalClickListener() {
      document.addEventListener('click', this.handleGlobalClick)
    },

    /**
     * 处理全局点击事件
     */
    handleGlobalClick(event) {
      if (!this.$el.contains(event.target)) {
        this.showSuggestions = false
        this.activeSuggestionIndex = -1
      }
    },

    /**
     * Logo 加载错误处理
     */
    handleLogoError() {
      this.logoLoadError = true
      console.warn('Logo 加载失败，使用文字替代')
    },

    /**
     * Logo 加载成功
     */
    handleLogoLoad() {
      this.logoLoadError = false
    },

    /**
     * 处理联系方式点击
     */
    handleContactClick(contact) {
      if (!contact.action) return

      switch (contact.action) {
        case 'call':
          if (contact.phone) {
            window.location.href = `tel:${contact.phone}`
          }
          break
        case 'chat':
          this.openCustomerService()
          break
        default:
          console.log(`未定义的联系方式: ${contact.action}`)
      }

      // 统计埋点
      this.trackEvent('contact_click', contact.id)
    },

    /**
     * 打开客服系统
     */
    openCustomerService() {
      // 这里可以集成具体的客服系统
      // this.$message.info('客服功能开发中...')
    },

    /**
     * 搜索框获得焦点
     */
    handleSearchFocus() {
      this.isSearchFocused = true
      if (this.searchKeyword.trim()) {
        this.showSuggestions = true
      } else {
        this.showSearchHistory()
      }
    },

    /**
     * 搜索框失去焦点
     */
    handleSearchBlur() {
      this.isSearchFocused = false
      // 延迟隐藏建议，给点击事件时间
      setTimeout(() => {
        this.showSuggestions = false
        this.activeSuggestionIndex = -1
      }, 200)
    },

    /**
     * 搜索输入处理
     */
    handleSearchInput() {
      // 清除之前的定时器
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }

      // 设置防抖
      this.searchDebounceTimer = setTimeout(() => {
        if (this.searchKeyword.trim()) {
          this.fetchSearchSuggestions()
        } else {
          this.showSearchHistory()
        }
      }, this.searchConfig.debounceDelay)
    },

    /**
     * 获取搜索建议
     */
    async fetchSearchSuggestions() {
      if (!this.searchKeyword.trim()) return

      try {
        // 这里可以调用实际的搜索建议 API
        // const suggestions = await this.$api.getSearchSuggestions(this.searchKeyword)

        // 模拟数据
        const mockSuggestions = [
          { id: 1, text: `${this.searchKeyword}相关项目`, icon: 'el-icon-folder', category: '项目' },
          { id: 2, text: `${this.searchKeyword}招标公告`, icon: 'el-icon-document', category: '公告' },
          { id: 3, text: `${this.searchKeyword}企业信息`, icon: 'el-icon-office-building', category: '企业' }
        ]

        this.searchSuggestions = mockSuggestions.slice(0, this.searchConfig.maxSuggestions)
        this.showSuggestions = true
        this.activeSuggestionIndex = -1
      } catch (error) {
        console.error('获取搜索建议失败:', error)
        this.searchSuggestions = []
      }
    },

    /**
     * 显示搜索历史
     */
    showSearchHistory() {
      if (this.searchHistory.length > 0) {
        this.searchSuggestions = this.searchHistory.map((item, index) => ({
          id: `history_${index}`,
          text: item,
          icon: 'el-icon-time',
          category: '历史记录'
        }))
        this.showSuggestions = true
      }
    },

    /**
     * 建议列表导航
     */
    handleSuggestionNavigation(direction) {
      if (!this.showSuggestions || this.searchSuggestions.length === 0) return

      const maxIndex = this.searchSuggestions.length - 1

      if (direction === 1) {
        // 下箭头
        this.activeSuggestionIndex = this.activeSuggestionIndex < maxIndex
          ? this.activeSuggestionIndex + 1
          : 0
      } else {
        // 上箭头
        this.activeSuggestionIndex = this.activeSuggestionIndex > 0
          ? this.activeSuggestionIndex - 1
          : maxIndex
      }

      // 更新输入框内容
      if (this.activeSuggestionIndex >= 0) {
        this.searchKeyword = this.searchSuggestions[this.activeSuggestionIndex].text
      }
    },

    /**
     * 选择建议项
     */
    selectSuggestion(suggestion) {
      this.searchKeyword = suggestion.text
      this.showSuggestions = false
      this.activeSuggestionIndex = -1
      this.handleSearch()
    },

    /**
     * 高亮搜索关键词
     */
    highlightSearchTerm(text) {
      if (!this.searchKeyword.trim()) return text

      const regex = new RegExp(`(${this.searchKeyword})`, 'gi')
      return text.replace(regex, '<mark>$1</mark>')
    },

    /**
     * 清除搜索
     */
    clearSearch() {
      this.searchKeyword = ''
      this.showSuggestions = false
      this.activeSuggestionIndex = -1
      this.searchSuggestions = []
      this.$refs.searchInput?.focus()
    },

    /**
     * 执行搜索
     */
    async handleSearch() {
      const keyword = this.searchKeyword.trim()
      if (!keyword) {
        this.$message.warning('请输入搜索关键词')
        return
      }

      this.isSearching = true
      this.showSuggestions = false

      try {
        // 保存搜索历史
        this.saveSearchHistory(keyword)

        // 发送搜索事件
        this.$emit('search', {
          keyword,
          timestamp: Date.now(),
          source: 'header_search'
        })

        // 统计埋点
        this.trackEvent('search', keyword)

        // 模拟搜索延迟
        await new Promise(resolve => setTimeout(resolve, 800))

      } catch (error) {
        console.error('搜索失败:', error)
        this.$message.error('搜索失败，请稍后重试')
      } finally {
        this.isSearching = false
      }
    },

    /**
     * 加载搜索历史
     */
    loadSearchHistory() {
      try {
        const history = localStorage.getItem('search_history')
        this.searchHistory = history ? JSON.parse(history) : []
      } catch (error) {
        console.warn('加载搜索历史失败:', error)
        this.searchHistory = []
      }
    },

    /**
     * 保存搜索历史
     */
    saveSearchHistory(keyword) {
      try {
        // 移除重复项
        this.searchHistory = this.searchHistory.filter(item => item !== keyword)
        // 添加到首位
        this.searchHistory.unshift(keyword)
        // 保持最多10条记录
        this.searchHistory = this.searchHistory.slice(0, 10)

        localStorage.setItem('search_history', JSON.stringify(this.searchHistory))
      } catch (error) {
        console.warn('保存搜索历史失败:', error)
      }
    },

    /**
     * 统计埋点
     */
    trackEvent(action, label) {
      if (window._hmt) {
        window._hmt.push(['_trackEvent', 'top_area', action, label])
      }
      console.log(`Track event: ${action} - ${label}`)
    },

    /**
     * 清理资源
     */
    cleanup() {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }
      document.removeEventListener('click', this.handleGlobalClick)
    }
  }
}
</script>

<style lang="less" scoped>
// 顶部导航栏
.nav-tabs {
  display: flex;
  background: white;
  height: 56px;


  .tab-item {
    min-width: 149px;
    max-width: 200px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    font-family: PingFang SC, PingFang SC;
    font-size: 16px;
    font-weight: 500;

    &:hover {
      color: #005EEC;
      background: #005EEC;
      color: white;
    }

    &.active {
      color: white;
      background: #005EEC;
      border-bottom-color: #005EEC;
    }
  }
}



input::placeholder {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.top-area {
  width: 100%;
  height: 59px;
  background: #E7F0FF;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;

  .container {
    width: 100%;
    margin: 0 20px;
    justify-content: space-between;
    display: flex;
    align-items: center;
    height: 100%;
  }
}

// 左侧：Logo和标题
.left-section {
  display: flex;
  align-items: center;

  .logo-img {
    width: 200px;
    height: 50px;
  }

  .logo-fallback {
    background: rgba(255, 255, 255, 0.9);
    color: #1890ff;
    padding: 12px 20px;
    border-radius: 8px;
    font-size: 20px;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

// 中间：联系信息
.center-section {
  display: flex;
  align-items: center;
  gap: 20px;

  .contact-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #08090A;

    &:hover {
      opacity: 0.8;
    }

    .phone-img {
      width: 17px;
      height: 17px;
    }
  }
}

// 搜索框
.search-container {
  margin-left: 50px;
  display: flex;
  align-items: center;
  background: white;
  border-radius: 2px;
  overflow: hidden;

  .search-input {
    width: 125px;
    height: 27px;
    border: none;
    outline: none;
    padding: 0 12px;
    font-size: 14px;
    color: #333;
  }

  .search-btn {
    height: 27px;
    width: 61px;
    background: #005EEC;
    color: white;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    transition: background-color 0.3s;

    .search-img {
      width: 17px;
      height: 17px;
    }

    .search-text {
      height: 17px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
    }

    &:hover:not(:disabled) {
      background: #40a9ff;
    }

    &:disabled {
      background: #d9d9d9;
      cursor: not-allowed;
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
}

// 搜索建议下拉框
.search-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  border-top: 1px solid #e8e8e8;
}

.suggestion-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f5f5f5;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &.suggestion-active {
    background: #f8f9fa;
  }

  .suggestion-icon {
    color: #666;
    font-size: 14px;
    flex-shrink: 0;
  }

  .suggestion-text {
    flex: 1;
    font-size: 14px;
    color: #333;

    :deep(mark) {
      background: #fffbe6;
      color: #1890ff;
      padding: 0 2px;
      border-radius: 2px;
    }
  }

  .suggestion-category {
    font-size: 12px;
    color: #999;
    background: #f5f5f5;
    padding: 2px 6px;
    border-radius: 10px;
    flex-shrink: 0;
  }
}
</style>
